import React, { useState, useEffect } from 'react';
import { FaArrowUp, FaArrowDown, FaSync } from 'react-icons/fa';
import { useNavigate, Link, useLocation } from "react-router-dom";
import StatusBadge from "../../../js/buttonstatus.jsx";
import { RingLoader, BarLoader } from "react-spinners";
import { AccountsOrdersHeader, AccountsOrdersRow } from "./accounts_orders.jsx";
import PartnerProfile from "../../../community/profile/partner_profile.jsx";


export default function ProductTable({
    data_acount,
    set_data_acount,
    nutxuly,
    muahang,
    account_edits,
    idservice,
    dasaochep,
    category_main
}) {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [buyerUsername, setBuyerUsername] = useState('');
    const [activeBuyerId, setActiveBuyerId] = useState(null);
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const handleShowBuyer = (rowId, username) => {
        setActiveBuyerId((current) => {
            const next = current === rowId ? null : rowId;
            setBuyerUsername(next ? username : '');
            return next;
        });
    };
    const getIcon = (colKey) => {
        // Nếu chưa sort cột này, hiển thị FaSync (màu xám) ngay từ đầu
        if (sortConfig.key !== colKey) {
            return <FaSync className="inline ml-1 text-xs text-gray-300" />;
        }
        // Nếu đã sort rồi thì hiển thị mũi tên tăng/giảm
        return sortConfig.direction === 'ascending'
            ? <FaArrowUp className="inline ml-1 text-xs" />
            : <FaArrowDown className="inline ml-1 text-xs" />;
    };
    const onSort = (key) => {
        // Mặc định lần đầu nhấn là descending (cao → thấp)
        let direction = 'descending';
        // Nếu đang sort trên cùng 1 cột và đang là descending, thì chuyển thành ascending
        if (sortConfig.key === key && sortConfig.direction === 'descending') {
            direction = 'ascending';
        }
        setSortConfig({ key, direction });

        // Map key hiển thị sang field thật trong data
        const keyMap = {
            price: 'accounts_price',
            amount: 'accounts_amount',
            mode: 'accounts_type',     // nếu cần map thêm
            status: 'accounts_status'  // nếu cần map thêm
        };
        const field = keyMap[key] || key;

        const sorted = [...data_acount].sort((a, b) => {
            let aVal = a[field] ?? a[key] ?? '';
            let bVal = b[field] ?? b[key] ?? '';

            // Thử chuyển sang số (loại bỏ ký tự không phải số/.-)
            const normalizeNumber = v => {
                const s = String(v).trim();
                // thay dấu phẩy bằng dấu chấm nếu user có dùng (ví dụ "1,234.56" hoặc "1.234,56" tuỳ locale)
                const cleaned = s.replace(/[,]/g, '.').replace(/[^\d.-]/g, '');
                const n = parseFloat(cleaned);
                return Number.isNaN(n) ? null : n;
            };

            const aNum = normalizeNumber(aVal);
            const bNum = normalizeNumber(bVal);

            if (aNum !== null && bNum !== null) {
                if (aNum < bNum) return direction === 'ascending' ? -1 : 1;
                if (aNum > bNum) return direction === 'ascending' ? 1 : -1;
                return 0;
            }

            // Fallback: so sánh string case-insensitive
            const aStr = String(aVal).toLowerCase();
            const bStr = String(bVal).toLowerCase();
            if (aStr < bStr) return direction === 'ascending' ? -1 : 1;
            if (aStr > bStr) return direction === 'ascending' ? 1 : -1;
            return 0;
        });

        set_data_acount(sorted);
    };

    return (
        <>

            {category_main == 'accounts_orders' && buyerUsername && (
                <div className="mb-2 mt-2 mx-2">
                    <div className="mb-2 flex justify-end">
                        <button
                            type="button"
                            onClick={() => setBuyerUsername('')}
                            className="rounded bg-white px-3 py-1 text-xl font-semibold text-gray-700 shadow"
                        >
                            x
                        </button>
                    </div>
                    <PartnerProfile partnerUsername={buyerUsername} />
                </div>
            )}
            <table className="mt-1 table-fixed relative w-full border border-separate text-break text-sm">
                <thead className="bg-blue-500 text-white">
                    <tr>
                        {category_main == 'accounts_services' && (
                            <>
                                <th className="py-2 px-1" style={{ width: '10%' }}>
                                    id
                                </th>
                                <th className="py-2 px-1" style={{ width: '27%' }}>
                                    Tên sản phẩm
                                </th>
                                <th
                                    className="py-2 px-1 text-left cursor-pointer select-none"
                                    style={{ width: '10%' }}
                                    onClick={() => onSort('price')}
                                >
                                    Giá{getIcon('price')}
                                </th>
                                <th
                                    className="py-2 px-1 cursor-pointer select-none"
                                    style={{ width: '10%' }}
                                    onClick={() => onSort('amount')}
                                >
                                    Hiện có{getIcon('amount')}
                                </th>
                                <th
                                    className="py-2 px-1 cursor-pointer select-none"
                                    style={{ width: '12%' }}
                                >
                                    Chế độ {getIcon('mode')}
                                </th>
                                <th
                                    className="py-2 px-1 cursor-pointer select-none"
                                    style={{ width: '12%' }}
                                >
                                    Trạng thái {getIcon('status')}
                                </th>
                                <th className="py-2 px-1 text-left" style={{ width: '50%' }}>
                                    Mô tả
                                </th>
                            </>
                        )}
                        {category_main == 'accounts_seller' && (
                            <>
                                <th className="py-2 px-1" style={{ width: '10%' }}>
                                    id
                                </th>
                                <th className="py-2 px-1" style={{ width: '20%' }}>
                                    Tên sản phẩm
                                </th>
                                <th
                                    className="py-2 px-1 text-left cursor-pointer select-none"
                                    style={{ width: '10%' }}
                                    onClick={() => onSort('price')}
                                >
                                    Giá{getIcon('price')}
                                </th>
                                <th
                                    className="py-2 px-1 cursor-pointer select-none"
                                    style={{ width: '10%' }}
                                    onClick={() => onSort('amount')}
                                >
                                    Hiện có{getIcon('amount')}
                                </th>
                                <th
                                    className="py-2 px-1 cursor-pointer select-none"
                                    style={{ width: '50%' }}
                                >
                                    Đang bán
                                </th>
                                <th className="py-2 px-1 text-left" style={{ width: '50%' }}>
                                    Đã bán
                                </th>
                            </>
                        )}
                        {category_main == 'accounts_orders' && (
                            <>
                                <AccountsOrdersHeader getIcon={getIcon} onSort={onSort} />
                            </>
                        )}
                    </tr>
                </thead>

                <tbody>
                    {data_acount && data_acount.map(item_account => (
                        <tr
                            key={item_account.id}
                            className="bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 lg:text-black"
                        >
                            {category_main == 'accounts_orders' ? (
                                <AccountsOrdersRow
                                    item_account={item_account}
                                    nutxuly={nutxuly}
                                    account_edits={account_edits}
                                    switch_router={switch_router}
                                    category_main={category_main}
                                    activeBuyerId={activeBuyerId}
                                    onShowBuyer={handleShowBuyer}
                                />
                            ) : (
                                <>
                                    <td className="py-2 px-1 font-medium capitalize">{item_account.id}</td>
                                    <td className="py-3 px-2 font-medium capitalize">
                                        <Link className="flex items-center justify-between flex-1 text-black no-underline"
                                            to={`/shop/accounts/product/play/${item_account.accounts_alias}_${item_account.id}`}
                                        >
                                            {item_account.accounts_caption}
                                            <div className="text-xl">
                                                {'\u27A4'}
                                            </div>
                                        </Link>
                                    </td>
                                    {category_main == 'accounts_services' && (
                                        <>
                                            <td className="py-2 px-1">{item_account.accounts_price}</td>
                                            <td className="py-2 px-1">{item_account.accounts_amount}</td>
                                            <td className="py-2 px-1">
                                                {item_account.accounts_type === "local"
                                                    ? "Trong kho"
                                                    : item_account.accounts_type === "api"
                                                        ? "Qua API"
                                                        : item_account.accounts_type}
                                            </td>
                                            <td className="py-2 px-1">
                                                <StatusBadge status={item_account.accounts_status} />
                                            </td>
                                            <td className="py-2 px-1">

                                                <div id={item_account.id}>
                                                    <div dangerouslySetInnerHTML={{ __html: item_account.accounts_description }} />
                                                    <div className="float-right flex space-x-2">
                                                        <button
                                                            disabled={nutxuly === 1}
                                                            onClick={() => account_edits(item_account, category_main)}
                                                            className="text-xs flex font-medium rounded-full px-4 py-2 space-x-1 bg-white text-black"
                                                        >
                                                            {nutxuly === 1 && (
                                                                <div className="spinner-border spinner-border-sm" role="status" />
                                                            )}
                                                            <div>{idservice === item_account.id ? dasaochep : 'Sửa sản phẩm'}</div>
                                                        </button>
                                                        <button
                                                            disabled={nutxuly === 1}
                                                            onClick={() => {
                                                                const targetCategory = 'accounts_seller';
                                                                account_edits(item_account, targetCategory);
                                                            }}
                                                            className="text-xs flex font-medium rounded-full px-4 py-2 space-x-1 bg-white text-black"
                                                        >
                                                            {nutxuly === 1 && (
                                                                <div className="spinner-border spinner-border-sm" role="status" />
                                                            )}
                                                            <div>{idservice === item_account.id ? dasaochep : 'Sửa tài nguyên'}</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </>
                                    )}
                                    {category_main == 'accounts_seller' && (
                                        <>
                                            <td className="py-2 px-1">{item_account.accounts_price}</td>
                                            <td className="py-2 px-1">{item_account.accounts_amount}</td>
                                            <td className="py-2 px-1">{item_account.accounts_vip_now}</td>
                                            <td className="py-2 px-1">
                                                <div id={item_account.id}>
                                                    <div dangerouslySetInnerHTML={{ __html: item_account.accounts_vip_sold }} />
                                                    <div className="float-right">
                                                        <button
                                                            className="text-xs flex font-medium rounded-full px-0 py-0 space-x-1 bg-white text-black"
                                                        >
                                                            {nutxuly === 1 && (
                                                                <div className="spinner-border spinner-border-sm" role="status" />
                                                            )}
                                                            <div>
                                                                {item_account.accounts_type === "local" ? (
                                                                    <button
                                                                        disabled={nutxuly === 1}
                                                                        onClick={() => account_edits(item_account, category_main)}
                                                                        className="text-xs flex font-medium rounded-md px-2 py-1 items-center bg-white text-black border"
                                                                    >
                                                                        {nutxuly === 1 && (
                                                                            <div className="spinner-border spinner-border-sm mr-1" role="status" />
                                                                        )}
                                                                        <div>
                                                                            {idservice === item_account.id ? dasaochep : "sửa tài nguyên"}
                                                                        </div>
                                                                    </button>
                                                                ) : item_account.accounts_type === "api" ? (
                                                                    <div className="flex space-x-1">
                                                                        <button
                                                                            disabled={nutxuly === 1}
                                                                            onClick={() => account_edits(item_account, category_main)}
                                                                            className="text-xs flex font-medium rounded-md px-2 py-1 items-center bg-white text-black border"
                                                                        >
                                                                            {nutxuly === 1 && (
                                                                                <div className="spinner-border spinner-border-sm mr-1" role="status" />
                                                                            )}
                                                                            <div>
                                                                                {idservice === item_account.id ? dasaochep : "sửa tài nguyên"}
                                                                            </div>
                                                                        </button>

                                                                        <button
                                                                            disabled={nutxuly === 1}
                                                                            onClick={() => switch_router('/shop/accounts/sellers/api/settings')}
                                                                            className="text-xs flex font-medium rounded-md px-2 py-1 items-center bg-white text-black border"
                                                                        >
                                                                            {nutxuly === 1 && (
                                                                                <div className="spinner-border spinner-border-sm mr-1" role="status" />
                                                                            )}
                                                                            <div>
                                                                                {idservice === item_account.id ? dasaochep : "sửa api"}
                                                                            </div>
                                                                        </button>
                                                                    </div>
                                                                ) : null}


                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </>
                                    )}
                                </>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>


            <br />  <br />
        </>
    );
}
